export const CONNECT_CEI = 'CONNECT_CEI';
export const SHOW_MODAL_CONNECT_CEI = 'SHOW_MODAL_CONNECT_CEI';
export const ERROR_CONECT_CEI = 'ERROR_CONECT_CEI';
export const CLEAR_STATE_USUARIO = 'CLEAR_STATE_USUARIO';
export const ERROR_GET_AUTORIZACAO_CEI = 'ERROR_GET_AUTORIZACAO_CEI';
export const GET_AUTORIZACAO_CEI = 'GET_AUTORIZACAO_CEI';
export const ERROR_ATIVIDADES = 'ERROR_ATIVIDADES,';
export const GET_MINHAS_ATIVIDADES_PERIODO = 'GET_MINHAS_ATIVIDADES_PERIODO';
export const SET_DATA_CONTEXT_ATIVIDADES = 'SET_DATA_CONTEXT_ATIVIDADES';
